<template lang="pug">
  .it-audit-quotation(v-loading="loading")
    .it-audit-quotation__title
      span {{ $t('审核方案报价') }}
      el-input(
        v-model="keyword"
        :placeholder="$t('请输入供应商名称')"
        @keyup.enter.native="fetchList"
      )
        i(
          slot="suffix"
          class="el-input__icon el-icon-search"
          style="cursor: pointer"
        )
    template(v-if="list.length === 0")
      span(style="color:#808080") {{ $t('抱歉，没有您要找的供应商') }}!
    audit-sub-item(
      v-for="(i,index) in list"
      :data="i"
      :key="index"
      :index="index"
      :extendAll="extendAll"
      @update="fetchList"
    )
    template(v-if="versions.length !== 0")
      title-bar(style="margin-top: 32px") {{ $t('历史版本') }}
      div(style="padding: 0 20px;margin-bottom: 50px")
        template(v-for="item in versions")
          audit-versions-item(:item = "item" :auditType="5")

</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import AuditVersionsItem from '@/components/AuditVersions/AuditVersionsItem'
import { flatten } from 'lodash'
import AuditSubItem from './ProcurementAuditSFSQuotation/AuditSubItem'

const getApproveHistory = (id, businessType, auditType) => {
  return axios.get('/management/subfinal/getApproveHistory', {
    params: {
      id: id,
      business_type: businessType,
      audit_type: auditType
    }
  })
}

export default {
  components: {
    TitleBar,
    FooterButton,
    AuditVersionsItem,
    AuditSubItem
  },
  data () {
    return {
      loading: true,
      list: [],
      versions: [],
      hasGetHistory: false,
      keyword: ''
    }
  },
  computed: {
    extendAll () {
      return this.keyword !== ''
    },
    campaign () {
      return this.$store.state.campaign
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    businessType () {
      return this.$store.state.campaign.businessType
    },
    taskId () {
      return this.$store.state.campaign.taskId
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.loading = true
      axios.get('/management/subfinal/getVendorProgressForQuotation', {
        params: {
          campaign_id: this.campaign.id,
          is_need_it: true,
          keyword: this.keyword
        }
      })
        .then(res => {
          this.loading = false
          for (let i = 0; i < res.length; i++) {
            for (let j = 0; j < res[i].sub_final_scope_vendor.length; j++) {
              res[i].sub_final_scope_vendor[j].approve_status = res[i].sub_final_scope_vendor[j].it_approve_status
            }
          }
          this.list = res
          this.loading = false
          if (this.keyword !== '' || this.hasGetHistory) {
            return
          }
          this.getApproveHistory()
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    getApproveHistory () {
      let ItTableDataVendors = flatten(this.list.map(i => i.sub_final_scope_vendor))
      Promise.all(ItTableDataVendors.map(i => {
        return getApproveHistory(i.sub_final_scope_vendor_id, 4, 5)
      }))
        .then(res => {
          this.hasGetHistory = true
          this.versions = flatten(res)
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    onConfirm () {
      this.loading = true
      axios.get('/management/subfinal/approvePriceForIt', {
        params: {
          campaign_id: this.campaign.id,
          approve_result: this.auditData.result,
          servlet_path: this.$route.path,
          remark: this.auditData.remark,
          task_id: this.taskId
        }
      })
        .then(res => {
          this.loading = false
          this.$router.push('/campaign/process')
        })
    }
  }
}
</script>

<style lang="stylus">
.it-audit-quotation
  .it-audit-quotation__title
    display flex
    align-items center
    justify-content space-between
    margin 3px 0 11px
    > span
      color $title-color
      font-size 16px
      font-weight 500
  .el-input
    width 200px
  .title-bar
    margin-bottom 0
</style>
